import React,{ useState , useEffect } from 'react';
import {animateScroll as scroll} from 'react-scroll';
import {FaBars} from 'react-icons/fa'
import {Nav,
     NavbarContainer,
      NavLogo
    ,MobileIcon,NavItem ,NavMenu,NavLinks ,
NavBtn,NavBtnLink} from './NavbarElements';


const Navbar = ({toggle}) =>{

    const [scrollNav,setScrollNav] = useState(false);
    const [btn,setBtn] = useState(true);

    const changeNav = () => {
        if(window.scrollY >=80){
            setScrollNav(true);
        }else{
            setScrollNav(false);
        }
    }
    const changeBtn = () => {
        if(window.scrollY >=500){
            setBtn(true);
        }else{
            setBtn(false);
        }
    }

    useEffect(() =>{
        window.addEventListener('scroll',changeBtn);
    },[])
    useEffect(() =>{
        window.addEventListener('scroll',changeNav);
    },[])

    const toggleHome = () =>{
        scroll.scrollToTop();
    };

    return ( 
        <Nav scrollNav={scrollNav}>
            <NavbarContainer>
                <NavLogo to="/" onClick={toggleHome}>Elad Barzilay</NavLogo>
                <MobileIcon onClick={toggle}>
                    <FaBars/>
                </MobileIcon>
                <NavMenu>
                    <NavItem>
                        <NavLinks to="about" smooth={true} duration={500} spy={true}
                        exact={true} offset={-80} >About</NavLinks>
                    </NavItem>
                    <NavItem>
                        <NavLinks to="projects" smooth={true} duration={500} spy={true}
                        exact={true} offset={-80}>Projects</NavLinks>
                    </NavItem> 
                    <NavItem>
                        <NavLinks to="contact" smooth={true} duration={500} spy={true}
                        exact={true} offset={-80}>Contact</NavLinks>
                    </NavItem>
                </NavMenu>
                <NavBtn >
                    <NavBtnLink to="/" onClick={toggleHome} smooth={true} duration={500} spy={true}
                        exact={true} offset={-80} btn={btn}>back to top</NavBtnLink>
                </NavBtn>
            </NavbarContainer>
        </Nav>  
    );
};
export default Navbar;